import type { Product } from "@repo/shared-types";
import { cn } from "@repo/ui/lib/utils";
import { Image } from "@repo/ui/components/image";
import { formatCurrency } from "@repo/ui/lib/format/format-currency";

interface ScanItemProps {
  children: React.ReactNode;
  className?: string;
}

export function ScanItem({ children, className }: ScanItemProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-2 bg-white rounded-xl p-4 w-full shadow-sm shadow-gray-500/50",
        className ?? ""
      )}
    >
      {children}
    </div>
  );
}

interface ScanItemProductProps {
  product: Product;
}

export function ScanItemProduct({ product }: ScanItemProductProps) {
  return (
    <ScanItem>
      <div className="flex items-center justify-center gap-2">
        <Image
          src={product.imageUrl}
          alt={product.name}
          className="size-10 object-contain"
        />
        <div className="text-md text-gray-500">{product.name}</div>
      </div>
      <div className="flex items-center justify-center gap-2">
        <span className="text-lg text-gray-500 font-medium!">
          {formatCurrency(product.price)}
        </span>
      </div>
    </ScanItem>
  );
}
